import React from 'react';
import { Row } from 'react-table';
import Button from '@alltrails/shared/denali/components/Button';
import Checkbox from '@alltrails/shared/components/checkboxes/Checkbox24';
import { useDispatch, useSelector } from '../../../redux/hooks';
import { getSelectedTrailsAlerts } from '../utils';
import { AlertDrawerActionTarget, AlertDrawerActionType, selectEditing, setVisible } from '../../../redux/slices/alertsDrawer/alertsDrawer';
import * as styles from './styles/styles.module.scss';

import { AlgoliaAlert } from '../../../types/alerts';

type SelectedTrailsAlternateTableHeaderProps = {
  getToggleAllPageRowsSelectedProps: () => { onChange: (e: React.ChangeEvent<HTMLInputElement>) => void };
  toggleAllPageRowsSelected: (set?: boolean) => void;
  totalRowCount: number;
  selectedFlatRows: Array<Row>;
  headerClass?: string;
};

const SelectedTrailsAlternateTableHeader = ({
  getToggleAllPageRowsSelectedProps,
  toggleAllPageRowsSelected,
  totalRowCount,
  selectedFlatRows,
  headerClass
}: SelectedTrailsAlternateTableHeaderProps): JSX.Element => {
  const { onChange } = getToggleAllPageRowsSelectedProps();
  const editingAlert = useSelector(selectEditing);
  const dispatch = useDispatch();
  const count = editingAlert ? totalRowCount : selectedFlatRows.length;
  const displayCount = `${count} Trail${count > 1 ? 's' : ''} ${editingAlert ? 'applied to alert' : 'selected'}`;
  const trailsWithAlerts = getSelectedTrailsAlerts(selectedFlatRows);
  const selectAllDisabled = count === totalRowCount;

  // Hide these two buttons if alertsDrawer is not yet enabled
  const alertsDrawerEnabled = useSelector(state => state.enabledFeatures.alertsDrawer);
  let editAlertButton = null;
  let addAlertButton = null;
  if (alertsDrawerEnabled) {
    const editAlertsDisabled = trailsWithAlerts.length === 0;
    let editAlertsOnClick = null;
    if (!editAlertsDisabled) {
      const alerts: AlgoliaAlert[] = [];
      trailsWithAlerts.forEach(trail => alerts.push(...trail.alerts));
      editAlertsOnClick = () => {
        dispatch(setVisible({ visible: true, action: AlertDrawerActionType.EDIT, target: AlertDrawerActionTarget.TRAILS, alerts }));
      };
    }
    const openAlertsDrawer = () => {
      dispatch(setVisible({ visible: true, action: AlertDrawerActionType.ADD, target: AlertDrawerActionTarget.TRAILS }));
    };
    editAlertButton = (
      <Button text="Edit Alert" disabled={editAlertsDisabled} onClick={editAlertsOnClick} testId="portal-trails-edit-alert" variant="flat" />
    );
    addAlertButton = <Button text="Add Alert" onClick={() => openAlertsDrawer()} testId="portal-trails-add-alert" variant="flat" />;
  }
  // Placeholder for tooltip from TOOLS-567
  const labelComponent: JSX.Element = null;

  return (
    <thead className={`${styles.displayCount} ${headerClass}`}>
      <tr>
        <th>
          <Checkbox
            id="select-all"
            className={styles.selectCell}
            labelComponent={labelComponent}
            name=""
            disabled={editingAlert}
            checked={!editingAlert}
            value=""
            onChange={onChange}
          />
        </th>
        <th>
          <span>{displayCount}</span>
        </th>
        <th className={styles.pushRight}>
          <Button
            text="Select All"
            disabled={selectAllDisabled}
            onClick={toggleAllPageRowsSelected}
            testId="portal-trails-select-all"
            variant="flat"
          />
          {editAlertButton}
          {addAlertButton}
        </th>
      </tr>
    </thead>
  );
};

export default SelectedTrailsAlternateTableHeader;
